import DataMapper from './DataMapper';
import FoCloseCases, { FoOpenCases } from '../../models/FoCloseCase';
import FoCloseRM, { FoOpenRM } from '../responsemodel/FoCloseRM';

export default class FoCloseCasesDataMapper extends DataMapper<FoCloseRM, FoCloseCases> {
    map = (rm: FoCloseRM) => {
        return new FoCloseCases(
            rm.id,
            rm.claim_number,
            rm.insured_name,
            rm.insured_location.state,
            rm.insured_location.district,
            rm.investigator_name,
            rm.case_type_name,
            rm.client_name
        );
    };

    mapOpen = (rm: FoOpenRM) => {
        return new FoOpenCases(
            rm.id,
            rm.claim_number,
            rm.insured_name,
            rm.insured_location.state,
            rm.insured_location.district,
            rm.investigator.map((item) => item.investigator_name).join(", "),
            rm.case_type_name,
            rm.client_name,
            rm.investigator ?? []
        );
    };
}